import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ItemService from "../../../services/OrderingServices/ItemService";
import ResponsiveDataManagement from "../../../Components/Common/ResponsiveManagementLayout";
import { formatDate } from "../../../Components/Common/FormatDate";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";
import toast from "react-hot-toast";

const PriceChangeLog = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const initialProductId = queryParams.get("productId") || "";

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [productId, setProductId] = useState(initialProductId);

  const fetchLogs = async (page = currentPage, size = pageSize) => {
    try {
      setLoading(true);
      const response = await ItemService.getPriceChangeLogs({
        productId: productId || undefined,
        pageNumber: page,
        pageSize: size,
      });

      setLogs(response.items || []);
      setTotalRows(response.totalCount || 0);
      setLoading(false);
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch price change logs");
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(currentPage, pageSize);
  }, [currentPage, pageSize, productId]);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * pageSize + index + 1,
      width: "80px",
    },
    {
      name: "Product Name",
      selector: (row) => row.productName,
      sortable: true,
      width: "250px",
    },
    {
      name: "Old Price",
      selector: (row) => row.oldPrice,
      cell: (row) => <NumberWithCommas number={row.oldPrice} />,
      sortable: true,
      right: true,
    },
    {
      name: "New Price",
      selector: (row) => row.newPrice,
      cell: (row) => <NumberWithCommas number={row.newPrice} />,
      sortable: true,
      right: true,
    },
    {
      name: "Changed At",
      selector: (row) => formatDate(row.changedAt),
      sortable: true,
      width: "200px",
    },
    {
      name: "Changed By",
      selector: (row) => row.changedBy,
      sortable: true,
    },
  ];

  const handlePaginationChange = ({ page, perPage }) => {
    setCurrentPage(page);
    setPageSize(perPage);
  };

  const stats = [
    {
      title: "Total Logs",
      value: totalRows,
      color: "#0d6efd",
      icon: "bx bx-history",
    },
  ];

  return (
    <div className="page-content p-0">
      <ResponsiveDataManagement
        title="Price Change Logs"
        pageTitle="Inventory"
        mobileCardTitle="Price Changes"
        data={logs}
        columns={columns}
        stats={stats}
        loading={loading}
        totalRows={totalRows}
        currentPage={currentPage}
        pageSize={pageSize}
        onPaginationChange={handlePaginationChange}
        showSearch={false} // API doesn't seem to support text search for logs yet
        emptyStateMessage="No price change logs found"
      />
    </div>
  );
};

export default PriceChangeLog;
